import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { authApi } from '../api';

const VerifyEmail: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');

  useEffect(() => {
    if (!token) { setState('error'); return; }
    let active = true;
    authApi.confirmEmailVerification(token)
      .then(() => { if (active) setState('ok'); })
      .catch(() => { if (active) setState('error'); });
    return () => { active = false; };
  }, [token]);

  return (
    <div className="app-shell bg-gradient-to-br from-green-950 via-green-900 to-black flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-black/40 backdrop-blur-md rounded-3xl p-8 shadow-2xl border border-green-800/50 text-center">
          {state === 'loading' && (
            <>
              <Loader2 className="h-12 w-12 text-emerald-400 mx-auto mb-3 animate-spin" />
              <p className="text-green-100">Verifying your email…</p>
            </>
          )}
          {state === 'ok' && (
            <>
              <CheckCircle2 className="h-14 w-14 text-emerald-500 mx-auto mb-3" />
              <h1 className="text-xl font-bold text-white mb-1">Email verified 🎉</h1>
              <p className="text-green-100/90 mb-5">You're all set. Time to relieve your mates of some cash.</p>
              <Link to="/" className="inline-block bg-emerald-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-emerald-500 transition">
                Go to FairPlay
              </Link>
            </>
          )}
          {state === 'error' && (
            <>
              <XCircle className="h-14 w-14 text-red-400 mx-auto mb-3" />
              <h1 className="text-xl font-bold text-white mb-1">Link expired or invalid</h1>
              <p className="text-green-100/90 mb-5">Sign in and resend the verification email from the banner.</p>
              <Link to="/login" className="inline-block bg-white/10 border border-white/20 text-white px-6 py-3 rounded-xl font-semibold hover:bg-white/20 transition">
                Back to sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
